/** Stato form bozza FIR digitale. */

export interface FirBozzaFormState {
  num_iscr_sito: string;
  codice_blocco: string;
  eer: string;
  quantita: string;
  unita_misura: string;
  stato_fisico: string;
  provenienza: string;
  caratteristiche_pericolo: string[];
  tipo_trasporto: string;
  produttore_cf: string;
  destinatario_cf: string;
  trasportatore_cf: string;
}

export function defaultFirBozzaForm(sito = "", codiceBlocco = ""): FirBozzaFormState {
  return {
    num_iscr_sito: sito,
    codice_blocco: codiceBlocco,
    eer: "",
    quantita: "100",
    unita_misura: "KG",
    stato_fisico: "S",
    provenienza: "S",
    caratteristiche_pericolo: [],
    tipo_trasporto: "Terrestre",
    produttore_cf: "",
    destinatario_cf: "",
    trasportatore_cf: "",
  };
}

function asRecord(v: unknown): Record<string, unknown> {
  return v && typeof v === "object" && !Array.isArray(v) ? (v as Record<string, unknown>) : {};
}

export function payloadToFirBozzaForm(payload: unknown, sitoFallback = ""): FirBozzaFormState {
  const base = defaultFirBozzaForm(sitoFallback);
  const p = asRecord(payload);
  if (!Object.keys(p).length) return base;
  const rifiuto = asRecord(p.rifiuto);
  const prod = asRecord(p.produttore);
  const dest = asRecord(p.destinatario);
  const tras = asRecord(p.trasportatore);
  const hp = rifiuto.caratteristiche_pericolo;
  return {
    num_iscr_sito: String(p.num_iscr_sito ?? sitoFallback),
    codice_blocco: String(p.codice_blocco ?? ""),
    eer: String(rifiuto.eer ?? "").replace(/\./g, ""),
    quantita: String(rifiuto.quantita ?? "100"),
    unita_misura: String(rifiuto.unita_misura ?? "KG"),
    stato_fisico: String(rifiuto.stato_fisico ?? "S"),
    provenienza: String(rifiuto.provenienza === "U" ? "U" : "S"),
    caratteristiche_pericolo: Array.isArray(hp) ? hp.map(String) : [],
    tipo_trasporto: String(tras.tipo_trasporto ?? "Terrestre"),
    produttore_cf: String(prod.codice_fiscale ?? prod.cf ?? prod.num_iscr_sito ?? ""),
    destinatario_cf: String(dest.codice_fiscale ?? dest.cf ?? dest.num_iscr_sito ?? ""),
    trasportatore_cf: String(tras.codice_fiscale ?? tras.cf ?? tras.num_iscr_sito ?? ""),
  };
}

export function buildFirBozzaPayload(form: FirBozzaFormState): Record<string, unknown> {
  const sito = form.num_iscr_sito.trim();
  const rifiuto: Record<string, unknown> = {
    eer: form.eer.replace(/\./g, ""),
    quantita: Number(form.quantita) || 0,
    unita_misura: form.unita_misura,
    stato_fisico: form.stato_fisico,
    provenienza: form.provenienza,
  };
  if (form.caratteristiche_pericolo.length > 0) {
    rifiuto.caratteristiche_pericolo = form.caratteristiche_pericolo;
  }
  const payload: Record<string, unknown> = {
    num_iscr_sito: sito,
    rifiuto,
    produttore: form.produttore_cf
      ? { num_iscr_sito: sito, codice_fiscale: form.produttore_cf }
      : { num_iscr_sito: sito },
    destinatario: form.destinatario_cf
      ? { num_iscr_sito: sito, codice_fiscale: form.destinatario_cf }
      : { num_iscr_sito: sito },
    trasportatore: {
      num_iscr_sito: sito,
      tipo_trasporto: form.tipo_trasporto,
      ...(form.trasportatore_cf ? { codice_fiscale: form.trasportatore_cf } : {}),
    },
  };
  if (form.codice_blocco.trim()) payload.codice_blocco = form.codice_blocco.trim();
  return payload;
}

